import { Avatar } from '@mui/material'

import libbySrc from '~/assets/images/about/libby.webp'
import rem from '~/utils/ui'

type TProps = {
  chatbotImgURL?: string
  variant?: 'small' | 'large' | 'xl'
}

function AssistantAvatar({
  chatbotImgURL = undefined,
  variant = 'large',
}: TProps) {
  const sizes = {
    small: {
      width: 32,
      height: 32,
    },
    large: {
      width: 48,
      height: 48,
    },
    xl: {
      width: 72,
      height: 72,
    },
  }

  return (
    <Avatar
      src={chatbotImgURL ?? libbySrc}
      sx={{
        ...sizes[variant],
        transition: 'all 1s ease-in-out',
        borderRadius: rem(8),
      }}
    />
  )
}

export default AssistantAvatar
